var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5935 0C30.9996 0 32.217 0.976596 32.522 2.34921L33.1887 5.34921C33.2373 5.56769 33.2607 5.78591 33.2608 6.00082L39 6C40.6569 6 42 7.34315 42 9V12C42 13.6569 40.6569 15 39 15H38.886L37.1616 45.1712C37.0709 46.7589 35.7569 48 34.1665 48H13.8335C12.2431 48 10.9291 46.7589 10.8384 45.1712L9.114 15H9C7.34315 15 6 13.6569 6 12V9C6 7.34315 7.34315 6 9 6H14.7398C14.7398 5.78111 14.7638 5.56288 14.8113 5.34921L15.478 2.34921C15.783 0.976596 17.0004 0 18.4065 0H29.5935ZM35.8287 15H12.1713L13.838 45H34.162L35.8287 15ZM31.9931 19.2049C31.9204 18.5288 31.2797 18 30.5 18C29.6716 18 29 18.597 29 19.3333V40.6667L29.0069 40.7951C29.0796 41.4712 29.7203 42 30.5 42C31.3284 42 32 41.403 32 40.6667V19.3333L31.9931 19.2049ZM24 18C24.7797 18 25.4204 18.5288 25.4931 19.2049L25.5 19.3333V40.6667C25.5 41.403 24.8284 42 24 42C23.2203 42 22.5796 41.4712 22.5069 40.7951L22.5 40.6667V19.3333C22.5 18.597 23.1716 18 24 18ZM18.9931 19.2049C18.9204 18.5288 18.2797 18 17.5 18C16.6716 18 16 18.597 16 19.3333V40.6667L16.0069 40.7951C16.0796 41.4712 16.7203 42 17.5 42C18.3284 42 19 41.403 19 40.6667V19.3333L18.9931 19.2049ZM39 9H9V12H39V9ZM18.4065 3H29.5935L30.2602 6H17.7398L18.4065 3Z",
    fill: "#006FCF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.bea0fadf3b9f6521813cb8bb22cf4442.svg";
export { ForwardRef as ReactComponent };